import dynamic from 'next/dynamic';
import {createTranslator, useTranslations, type AbstractIntlMessages} from 'next-intl';
import withMainLayout from 'layouts/main';
import {pageMessagesProps} from 'helpers/i18n';
import HeroSection from '@/content/industry-professional-services/hero';
import shared from '../messages/en/shared.json';
import industryProfessionalServices from '../messages/en/industryProfessionalServices.json';

const FeaturesSection = dynamic(
  () => import('@/content/industry-professional-services/features-section'),
  {loading: () => null}
);
const SplitFeaturesSection = dynamic(
  () => import('@/content/industry-professional-services/split-features-section'),
  {loading: () => null}
);
const CustomerStoriesSection = dynamic(
  () => import('@/content/industry-professional-services/customer-stories-section'),
  {loading: () => null}
);
const FaqSection = dynamic(() => import('@/content/industry-professional-services/faq-section'), {
  loading: () => null
});
const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const IndustryProfessionalServicesPage = () => {
  const t = useTranslations('industryProfessionalServices.prefooter');

  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <SplitFeaturesSection />
      <CustomerStoriesSection />
      <FaqSection />
      <PreFooter title={t('title')} subtitle="" />
    </>
  );
};

type PageMessagesProps = {
  locale: string;
  messages: AbstractIntlMessages;
};

const seoMetas = (props: PageMessagesProps) => {
  const t = createTranslator({
    locale: props.locale,
    messages: props.messages
  }) as (key: string) => string;

  return {
    title: t('industryProfessionalServices.seo.title'),
    description: t('industryProfessionalServices.seo.description'),
    canonical: t('industryProfessionalServices.seo.canonical')
  };
};

export const messagesForIntl = {shared, industryProfessionalServices};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}

export default withMainLayout(IndustryProfessionalServicesPage, seoMetas as never);
